import { Component, OnInit, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { SpeakerService } from '../../speaker.service';
import { CommonApiService } from "../../common-api.service";
import { Challan, displayColumns, displayHeaders, filterParameters } from './challan.interface';
import { DatePipe } from '@angular/common';
import { FilterBuilderComponent } from '../filter-builder/filter-builder.component';
import { RenderFilterDropdownService } from '../../render-filter-dropdown.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ListStateService } from '../../list-state.service';

@Component({
  selector: 'app-challan',
  templateUrl: './challan.component.html',
  styleUrls: ['./challan.component.css']
})
export class ChallanComponent implements OnInit, OnDestroy {
  
	displayColumns = displayColumns;
	displayHeaders = displayHeaders;
	challan: Challan[] = [];
	filterFields: any[] =[]
    filterCriteria: any[] =[]
    doctorsOptions:any[] = [];
    companyOptions:any[] = [];
    pageIndex = environment.defaultPageIndexOnLoad;
    pageSize = environment.defaultPageSizeOnLoad;
    sortQuery = 'id:1';
    private destroy$ = new Subject<void>();

	@ViewChild('dynamicFilterContainer', { read: ViewContainerRef, static: true })
	dynamicFilterContainer!: ViewContainerRef;

	constructor(
		public speaker: SpeakerService,
		private api: CommonApiService,
		private datePipe: DatePipe,
		private dialog: MatDialog,
        private router: Router,
        private renderFilterDropdown: RenderFilterDropdownService,
        private listState: ListStateService
	) {}

	// common code above this line for all components
	transformDate(date: any) {
		date = new Date(date);
		var converteddate: any = this.datePipe.transform(date, 'dd-MM-yyyy');
		return converteddate;
	}

	ngOnInit(): void {
		this.speaker.model = 'challan';
		this.speaker.displayColumns = this.displayColumns;
		this.speaker.displayHeaders = this.displayHeaders;

        const cached = this.listState.restore(this.speaker.model);
        if (cached) {
            this.pageIndex = cached.pageIndex;
            this.pageSize = cached.pageSize;
            this.sortQuery = cached.sortQuery;
            this.filterCriteria = cached.filterCriteria;
            this.speaker.activeView = cached.activeView;
        }
        this.speaker.pageIndex = this.pageIndex;
        this.speaker.pageSize = this.pageSize;
        this.speaker.sortQuery = this.sortQuery;

        this.speaker.paginationChange$.pipe(takeUntil(this.destroy$)).subscribe(({ pageIndex, pageSize, sortQuery }) => {
            this.pageIndex = pageIndex;
            this.pageSize = pageSize;
            this.sortQuery = sortQuery;
            this.getListDetails();
        });
        this.speaker.activeView$.pipe(takeUntil(this.destroy$)).subscribe(() => this.getListDetails());

        this.getListDetails();

		this.onDropdownRenderOptions('doctor/list/display', this.doctorsOptions);
        this.onDropdownRenderOptions('company/list/display', this.companyOptions);


    }

	// dynamic func for dropdown loading in filters
	onDropdownRenderOptions(apiEndpoint: string, targetOptions: any[]) {
        this.renderFilterDropdown.onDropdownLoadOptions(apiEndpoint, targetOptions);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

	getListDetails() {
		const params: any = {
            offset: this.pageIndex,
            limit: this.pageSize,
            sort: this.sortQuery,
            active: this.speaker.activeView,
            filterCriteria: this.filterCriteria
		};

        this.api.postAll('challan/list/display', params).subscribe((res: any) => {
			this.challan = res.items;
			this.challan.forEach((element) => {
                element.is_proforma_invoiced = element.is_proforma_invoiced ? "Yes" : "No";
			});

			// Set the transformed response to the speaker service
            this.speaker.setListData(this.challan, res.rowCount, res.pageIndex, res.pageSize, res.allIds);
            this.listState.save(this.speaker.model, { pageIndex: this.pageIndex, pageSize: this.pageSize, sortQuery: this.sortQuery, filterCriteria: this.filterCriteria, activeView: this.speaker.activeView });
		});
	}

	// set options for dropdown filters
    getOptionArray<T>(modelName: any): T[] {
        const ModelOptionsMap: Record<string, T[]> = {
          doctor: this.doctorsOptions,
          company: this.companyOptions,
          // Add other model names and their corresponding options arrays here
        };
        
        const optionKey = ModelOptionsMap[modelName];
        return optionKey;
    }

	openDialogFilter() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'custom-dialog-container';
        dialogConfig.data = {
            filterFields: filterParameters.map(field => field),
        };
        const dialogRef = this.dialog.open(FilterBuilderComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.filterCriteria = result;
                this.pageIndex = environment.defaultPageIndexOnLoad;
                this.pageSize = environment.defaultPageSizeOnLoad;
                this.getListDetails();
            }
        });
    }

    resetFilters() {
        this.listState.clear(this.speaker.model);
        this.filterCriteria = []
        this.redirectTo(this.speaker.model);
    }

    //redirects to the expected route
    //this function will redirect to a dummy route and quickly return to the destination route without the user realizing it.
    redirectTo(uri:string){  
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
        this.router.navigate([uri]));
    }

}

